// v0.9.0 §1.1 — plane switcher: focuses the board on one plane's presence
// subset. "All" clears the filter (the primary/whole model). Lives in the
// board HUD's complications group (right side). This is the HUD-configured
// binding of the shared `PlaneSelect` (null entry labelled "All"); the same
// picker serves the view builder's `on` clause. Presentational — the host owns
// the plane list + selection (see `usePlaneSwitcher`); returns null when the
// model has no non-primary planes.

import { PlaneSelect } from "../components/pickers/PlaneSelect";
import { useTranslation } from "../i18n";

export interface PlaneSwitcherProps {
  readonly planes: readonly string[];
  readonly selected: string | null;
  readonly onSelect: (plane: string | null) => void;
}

export function PlaneSwitcher({ planes, selected, onSelect }: PlaneSwitcherProps) {
  const { t } = useTranslation("planeSwitcher");
  return (
    <PlaneSelect
      planes={planes}
      value={selected}
      onChange={onSelect}
      clearLabel={t("allLabel")}
      data-hud-region="planes"
      aria-label={t("ariaLabel")}
      title={t("title")}
    />
  );
}
